// ボトルのプロファイル
export const BOTTLE_50 = '/bottle-50';
export const BOTTLE_100 = '/bottle-100';
export const BOTTLE_150 = '/bottle-150';
export const BOTTLE_200 = '/bottle-200';
export const BOTTLE_250 = '/bottle-250';
export const BOTTLE_300 = '/bottle-300';
export const BOTTLE_400 = '/bottle-400';
export const BOTTLE_500 = '/bottle-500';

// サムネ系のプロファイル
export const THUMBNAIL_250 = '/thumbnail-250';
export const THUMBNAIL_300 = '/thumbnail-300';
export const THUMBNAIL_400 = '/thumbnail-400';
